import React, { useState } from 'react';
import { dateFormation } from '../../common/cores';

const TitleBox = (props) => {

    return (
      <div className="title_wrap">
        <div className="title_box">
          <div className="title">{props.title}</div>
        </div>
      </div>
    );
};

export default TitleBox;


// WEBPACK FOOTER //
// ./src/components/common/TitleBox.js